import { render } from "./TrayArrowDown.vue?vue&type=template&id=5dbf2618"
import script from "./TrayArrowDown.vue?vue&type=script&lang=js"
export * from "./TrayArrowDown.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__